export const VISIBILITY_ITEMS = {
    PUBLIC: "Public",
    DIRECT_MESSAGE: "Direct Message",
    CHAT: "Chat",
    INTERNAL: "Internal",
    EMAIL: "Email",
    '*': "All"
};